import { defineComponent as _defineComponent } from 'vue'
import Drawer from '../common/base/Drawer.vue';
import useSideBar from './useSideBarHooks';
import ManageMember from '../ManageMember';
import RoomMore from '../RoomMore';
import Chat from '../Chat/index';
import AITranscription from '../AITools/AITranscription.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  setup(__props) {

const { isSidebarOpen, title, handleClose, sidebarName } = useSideBar();

return { __sfc: true,isSidebarOpen, title, handleClose, sidebarName, Drawer, ManageMember, RoomMore, Chat, AITranscription }
}

})